<template>
    <div class="treeSelect">
        <input
            @focus="focus"
            :placeholder="placeholder"
            class="input-con"
            :class="{act:showChild}"
            readonly="readonly"
            type="text"
            :value="value"
        >
        <span class="icon-con">
            <i class="el-icon-arrow-down"></i>
        </span>

        <v-tree-select-child @close="close" v-model="showChild">
            <slot></slot>
        </v-tree-select-child>
    </div>
</template>
<script>
import Vue from "vue";
import treeSelectChild from "./treeSelectChild.vue";

export default {
    data() {
        return {
            showChild: false
        };
    },
    props: {
        placeholder: {
            type: String,
            default: false
        },
        value:{
            type: String,
            default: false
        }
    },
    components: {
        "v-tree-select-child": treeSelectChild
    },
    methods: {
        focus() {
            this.showChild = true;
            this.$nextTick(()=>{
                this.$emit('show')
            })
        },
        close() {
            this.showChild = false;
        },
        open() {}
    },
    mounted() {}
};
</script>

<style lang="scss" scoped>
.treeSelect {
    min-width: 200px;
    position: relative;
    .input-con {
        position: relative;
        font-size: 14px;
        display: inline-block;
        width: 100%;
        border: 1px solid #ddd;
        height: 33px;
        border-radius: 4px;
        cursor: pointer;
        padding-left: 15px;
        padding-right: 30px;
        transition: border-color 0.5s;
    }
    .input-con:hover {
        border-color: #bbb;
    }
    .act {
        border-color: #409eff;
    }
    .input-con:focus {
        outline: none;
    }
    .icon-con {
        position: absolute;
        right: 0;
        top: 0;
        height: 40px;
        width: 30px;
        text-align: center;
        color: #c0c4cc;
    }
}
</style>



// WEBPACK FOOTER //
// src/vue/components/treeSelect/treeSelect.vue